import { home_cn as homeIndex } from '../modules/home'
import { common_cn as common } from '../modules/common'
import { m_cn as m } from '../modules/m'
import { membership_cn } from '../modules/membership.js'
import { shopPage_cn } from '../modules/shopPage.js'
import { bindCompany_cn as bindCompany } from '../modules/bindCompany'
import { rateProducts_cn as rateProducts } from '../modules/rateProducts'
import { header_cn as header } from '../modules/header'
import { cn as joinUs } from '../modules/joinUs'
import { companySearchCn as companySearch } from '../modules/companySearch'
import { membershipListCn as membershipList } from '../modules/membershipList'
import { cn as company } from '../modules/company'
import { knowledge_cn as knowledge } from '../modules/knowledge'
import { riskControl_cn as riskControl } from '../modules/riskControl'
import { memberTools_cn as memberTools } from '../modules/memberTools'
import { standards_cn as standards } from '../modules/standards'
import { policy_cn as policy } from '../modules/policy'
import { resources_cn as resources } from '../modules/resources'
import { inquiryDetail_cn as inquiryDetail } from '../modules/inquiryDetail'
import { checkEmail_cn as checkEmail } from '../modules/checkEmail'
import { JCInsurance_cn as JCInsurance } from '../modules/JCInsurance'

export default defineI18nLocale(async () => {
  return {
    home: {
      header: {
        JoinMember: {
          title: 'JCtrans会员制产品',
          desc1: '汇聚全球优质货代企业',
          desc2: '打造安全信誉圈层',
          desc3: '帮助企业持续盈利',
        },
        Home: '首页',
        ChinesePortal: '中国站',
        Jc123: '货代导航',
        Solutions:{
          name: '解决方案',
          Business: '商机解决方案',
          Risk: '风控解决方案',
          Payment: '支付结算解决方案',
          Academy: '商学院',
          memberSuccess: '商家培训',
          salon:'城市沙龙',
          Club: '俱乐部',
          JCclub:'企业家俱乐部',
          Cargo: '货物和货代操作风险解决方案',
          Credit: '在线交易',
          Resources:'行业资讯'
        },
        // Event: '会议',
        Event: {
          name: '全球会议',
          app: 'APP',
          Home: 'JCtrans Event',
          globalEvent: '全球会议',
          Connect: 'JCtrans Connect⁺',
          mainStation: 'JCtrans Event',
        },
        Club: '企业家俱乐部',
        newProducts: {
          name: '热门产品',
          Membership:'会员体系',
          general: '普货联盟',
          specialty:'专项联盟',
          vendor: '供应商服务',
        },
        Products: {
          name: '产品',

          CrossBorderLogistic: '国际物流',
          OceanFCL: '海运整箱',
          InternationalAir: '国际空运',
          InternationalLand: '陆运运输',
          DomesticLogistics: '境内物流',
          Truck: '卡车',
          Warehouse: '仓储',

          SupplyChainSolutions: '供应链解决方案',
          BookingAgent: '订舱代理',
          CargoInsurance: '货物保险',
          CargoInsuranceConfirmText:
            '保险服务当前只面对中国用户开放，是否确认跳转？',
          Confirm: '确定',
          Cancel: '取消',
          FMCApplication: 'FMC资质服务',

          FinancialServices: '金融服务',
          JCtransPay: 'JCtrans Pay',
          TCS: 'TCS',
          QuickPayUSD: '美元快付',

          CustomsFiling: '海关申报',
          AMSFiling: 'AMS Filing',
          ISFFiling: 'ISF Filing',
          ACIFiling: 'ACI（EM）Filing',
          AFRFiling: 'AFR Filing',
          Qingdao: '青岛预配舱单',
          Shanghai: '上海预配舱单',
          CustomsClearance: '在线报关',

          JCtransEvent: 'JCtrans Event',
          Event: 'Event',

          FreightInquiry: '询盘大厅',
          QuoteRequest: '发布询盘',
          ForwarderHelper: '帮货代',
          ForwarderHzh: '找货代',
          ForwarderCircle: '货代圈',

          Intergrations: '集成对接',
          APIDeveloper: 'API 开发者文档',
        },

        Member: {
          name: '会员联盟',
          Introduction: '会员介绍',
          MembershipIntroduction: '会员介绍',
          BenefitsOverview: '会员权益',
          GeneralMembership: '普货联盟',
          JCElite: 'JC Elite',
          JCPremium: 'JC Premium',
          JCRising: 'JC Rising',
          SpecialtyMemberships: '专项联盟',
          JCProject: 'JC Projects',
          JCDangerousGoods: 'JC Dangerous Goods',
          JCeCommerce: 'JC eCommerce',
          JCRailway: 'JC Railway',
          SupplierMemberships: '供应商服务',
          JCClub: '企业家俱乐部',
          JCVendor: 'JC Vendor',
          MemberTools: '会员工具',
          BlackList: '风控指南',
          ApplicationList: '待审公示清单',
        },

        Selection: {
          name: '企业家俱乐部&臻选',
          Club: '企业家俱乐部',
          ClubDesc: `会员高效交流互动，业务精准对接合作`,
          Selection: 'JCtrans 臻选',
          SelectionDesc: `臻选优质一手供应商资源，让您的全链条物流服务更安全高效`,
          LearnMore: '了解更多',
          WCC: 'WCC Platform',
        },

        Tools: {
          name: '工具',
          Logi: '物流工具',
          ContainerTracking: '全链路跟踪',
          SchedulePlan: '船期查询',
          HScodeFinder: '海关编码',
          USLocal: '美国专区',
          USCRS: '美国清关放行时刻表',
          USHCF: '美国清关HS Code 查询',
          USTRF: '美国卡车运价查询',
        },

        KnowledgeCenter: {
          name: '资讯中心',
          News: '新闻',
          SuccessStory: '成功案例',
          LogiTalks: '高端访谈',
        },

        Company: {
          name: '公司',
          AboutUs: '关于我们',
          ContactUs: '联系我们',
          HelpCenter: '帮助中心',
        },
        JCPay: {
          name: 'JCPay',
          settlement: '全球会员间免费结算',
        },
        CompanyDirectory: '公司名录',
        CustomerManagement:'客户管理',
        NewEvent: {
          name: '全球会议',
          allYearEvent: '全年大会',
          RegionalEvent: '区域会议',
          exhibition: '联合参展',
          Academy:'商学院',
          action:'线下活动'
        },
        Risk: {
          name: '风险保障',
          protection: '纠纷/索赔',
          JCinsurance: '杰西保',
          assurance: '信保交易',
          member: '风险名单',
          prevention: '风险预防',
          introduction: '规则介绍',
          insurance: '货运险',
          liability: '货代责任险',
          order: '信保订单',
          transaction: '交易订单'
        },
        TradeIn: '交易入驻',

        news: '新闻资讯',

        resources: '资讯中心',
        newResources: {
          JCnews: 'JCtrans新闻',
          Logistics: '行业新闻',
          Experience: '货运经验',
          Area: '货运地区',
          Policy: '货运政策',
          Solutions: '货运解决方案',
          Knowledge: '货运知识',
          Story: '成功案例',
          Blog:'知识分享'
        }
      },
      footer: {
        Home: '首页',
        Event: '会议',
        Club: '企业家俱乐部',
        WCC: 'WCC Platform',
        Products: {
          name: '产品',

          CrossBorderLogistic: '国际物流',
          OceanFCL: '海运整箱',
          InternationalAir: '国际空运',
          InternationalLand: '陆运运输',
          DomesticLogistics: '境内物流',
          Truck: '卡车',
          Warehouse: '仓储',

          SupplyChainSolutions: '供应链解决方案',
          BookingAgent: '订舱代理',
          CargoInsurance: '货物保险',
          CargoInsuranceConfirmText:
            '保险服务当前只面对中国用户开放，是否确认跳转？',
          Confirm: '确定',
          Cancel: '取消',
          FMCApplication: 'FMC资质服务',

          FinancialServices: '金融服务',
          JCtransPay: 'JCtrans Pay',
          TCS: 'TCS',
          QuickPayUSD: '美元快付',

          CustomsFiling: '海关申报',
          AMSFiling: 'AMS Filing',
          Qingdao: '青岛预配舱单',
          Shanghai: '上海预配舱单',

          JCtransEvent: 'JCtrans Event',
          Event: '会议',

          FreightInquiry: '询盘大厅',
          QuoteRequest: '发布询盘',
          ForwarderHelper: '帮货代',
          ForwarderHzh: '找货代',
          ForwarderCircle: '货代圈',
        },

        Member: {
          name: '会员联盟',

          MembershipIntroduction: '会员介绍',
          BenefitsOverview: '会员权益',
          GeneralMembership: '普货联盟',
          JCElite: 'JC Elite',
          JCPremium: 'JC Premium',
          JCRising: 'JC Rising',
          SpecialtyMemberships: '专项联盟',
          JCProject: 'JC Projects',
          JCDangerousGoods: 'JC Dangerous Goods',
          JCeCommerce: 'JC eCommerce',
          JCRailway: 'JC Railway',
          SupplierMemberships: '供应商联盟',
          JCVendor: 'JC Vendor',
          MemberTools: '会员工具',
          BlackList: '风控指南',
          ApplicationList: '待审公示清单',
          JoinUs: '加入会员',
        },
        Tools: {
          name: '工具',
          ContainerTracking: '全链路跟踪',
          SchedulePlan: '船期查询',
          HScodeFinder: '海关编码',
        },

        Selection: {
          name: '企业家俱乐部&臻选',
          Club: '企业家俱乐部',
          ClubDesc: `会员高效交流互动，业务精准对接合作`,
          Selection: 'JCtrans 臻选',
          SelectionDesc: `臻选优质一手供应商资源，让您的全链条物流服务更安全高效`,
          LearnMore: '了解更多',
          WCC: 'WCC Platform',
        },

        KnowledgeCenter: {
          name: '资讯中心',
          News: '新闻',
          SuccessStory: '成功案例',
          LogiTalks: '高端访谈',
        },

        Company: {
          name: '公司',
          AboutUs: '关于我们',
          ContactUs: '联系我们',
          HelpCenter: '帮助中心',
          CustomerService: '官方客服',
        },

        CompanyDirectory: '公司名录',
      },

      totalNumber: {
        Members: '会员量',
        Countries: '国家',
        CountriesRe: '国家和区域',

        Cities: '城市',
        PortsPairsServed: '覆盖港口',
        Stores: '入驻商铺',
      },
      firstContent: {
        title: '链全球商机 ，帮货代盈利',
        label: '加入会员',
      },
      SearchBox: {
        Rates: '运价',
        Company: '公司',
        SalesLead: '销售机会',
        Schedules: '船期',
        Request: '获取报价',
        ContainerTracking: '全链路跟踪',
        PostInquiry: '发布询盘',
        Inquiry: '询盘',

        Sea: '海运',
        Air: '空运',
        TRANSPORTATIONBY: '运输方式',
        AddAnotherLoad: '添加箱型',
        // 海运运输方式枚举
        FullcontainerloadFCL: '整箱',
        FullcontainerloadLCL: '拼箱',
        // 空运运输方式枚举
        Generalcargo: '普通货物',
        ULDcontainer: '航空集装器',
        // 陆运运输方式枚举
        LandFCL: '满箱装载',
        LandFTL: '整车货运',
        LandLTL: '零担货运',

        Bulk: '散货',
        Type: '箱型',
        Quantity: '箱量',
        Select: '提交',

        WEIGHT: '重量',
        VOLUME: '体积',
        Location: '所在地',
        CompanyName: '公司名称',
        MemberID: '会员ID',
        Port: '港口',

        LAND: '陆运',
      },
      SpecialOffers: {
        title: '特价商品',
        from: '出口',
        to: '进口',
        GuaranteedSpace: '舱位保证',
        TopSeller: '优质商铺',
        YearsMember: '年会员',
      },

      RecommendedShops: {
        title: '推荐商家',
        ChatOnline: '在线咨询',
        ViewShop: '查看商铺',
      },
      ActiveSalesLeads: {
        title: '热门销售机会',
        WeightofcargoAir: '重量/体积',
        Weightofcargo: '箱型/箱量/重量',
        Cargoready: '货好时间',
        Product: '品名',
      },

      OurGlobalReach: {
        title: '我们的全球影响力',
        All: '全部',
        Asia: '亚洲',
        Europe: '欧洲',
        Africa: '非洲',
        Oceania: '大洋洲',
        NorthAmerica: '北美洲',
        SouthAmerica: '南美洲',
        Antarctica: '南极洲',
      },
      SuccessStory: {
        title: '成功案例',
      },

      CaseStudies: {
        title: '客户案例',
      },

      LogiTalks: {
        title: '高端访谈',
      },

      MemberVoice: {
        title: '会员之声',
      },

      RiskControl: {
        title: '风控指南',
      },

      BecomeAMmember: {
        title: '即刻链接全球货代',
      },

      Trustedby: {
        title: '客户及合作伙伴',
      },
      Dropdown: {
        AccountInformation: '账号信息',
        CompanyInformation: '企业信息',
        CompanyAccount: '企业账号管理',
        StoreInformation: '商铺信息',
        CustomerService: '客服中心',
      },

      JoinUs: '加入会员',

      ViewMore: '查看更多',
      SignIn: '登录',
      SignUp: '注册',
      SignOut: '退出',
      backOld: '返回经典版',
      Dashboard: '控制台',
    },
    serviceScope: {
      advantage: {
        fcl: {
          label: '海运整箱',
          tooltip: '√材料“{ApprovedMaterials}” 已经过SGS核验',
          material1: '带约号的订舱单',
          material2: '与船司合作协议扫描件',
          material3: '与{compName}的合作案例',
          materialList: [
            `带约号的订舱单`,
            `与船司合作协议扫描件`,
            `与{compName}的合作案例`,
          ],
        },
        lcl: {
          label: `海运拼箱`,
          tooltip: `√材料“与{compName}的合作案例” ，案例和客户评价已经过SGS核验，客户评价{score}分（满分10分）`,
          material1: ``,
          material2: ``,
          material3: ``,
          materialList: [],
        },
        air: {
          label: '空运',
          tooltip: `√材料“{ApprovedMaterials}” 已经过SGS核验`,
          material1: `IATA会员证书`,
          material2: `航司颁发的订舱资质证明`,
          material3: `购机合同或飞机所有权证明文件`,
          material4: `与{compName}的合作案例`,
          materialList: [
            `IATA会员证书`,
            `航司颁发的订舱资质证明`,
            `与航司的包机、包板协议`,
            `购机合同或飞机所有权证明文件`,
            `与{compName}的合作案例`,
          ],
        },
        Intermodal: {
          label: '多式联运',
          tooltip: `√材料“与{compName}的多式联运合作案例” ，案例和客户评价已经过SGS核验，客户评价{score}分（满分10分）`,
          material1: ``,
          material2: ``,
          material3: ``,
          materialList: [],
        },
        Warehousing: {
          label: '仓储',
          tooltip: `{ApprovedMaterials} 已经过SGS核验`,
          materialList: [`仓库租赁合同`, `仓库土地所有权证明或土地租赁证明`],
          material1: `仓库租赁合同`,
          material2: `仓库土地所有权证明或土地租赁证明`,
        },
        CustomsClearance: {
          label: '清关',
          tooltip: `{ApprovedMaterials} 已经过SGS核验`,
          materialList: [`清关资质证书`, `有稳定合作超过2年的清关行`],
          material1: `清关资质证明`,
        },
        Truck: {
          label: '拖车',
          tooltip: `{ApprovedMaterials} 已经过SGS核验`,
          materialList: [`道路运输许可证`],
          material1: `道路运输许可证`,
        },
        Soc: {
          label: 'SOC箱',
          tooltip: `{ApprovedMaterials} 已经过SGS核验`,
          materialList: [
            `集装箱购买合同或租赁合同`,
            `5张印刷有公司LOGO的集装箱的照片`,
          ],
          material1: `集装箱购买合同或租赁合同`,
          material2: `5张印刷有公司LOGO的集装箱的照片`,
        },
      },
      // 优势海运航线
      seaFreightAdvantageous: {
        label: '优势海运航线',
        tooltip: `{ApprovedMaterials} 已经过SGS核验`,
        materialList: [
          `带约号的订舱单`,
          `与船司合作协议扫描件`,
          `与{compName}的合作案例`,
        ],
        material1: `带约号的订舱单`,
        material2: `与船司合作协议扫描件`,
        material3: `与{compName}的合作案例`,
      },
      // 优势空运航线
      airFreightAdvantageous: {
        label: '优势空运航线',
        tooltip: `{ApprovedMaterials} 已经过SGS核验`,
        materialList: [
          `IATA会员证书`,
          `航司颁发的订舱资质证明`,
          `与航司的包机、包板协议`,
          `购机合同或飞机所有权证明文件`,
          `与{compName}的合作案例`,
        ],
        material1: `IATA会员证书`,
        material2: `航司颁发的订舱资质证明`,
        material3: `与航司的包机、包板协议`,
        material4: `购机合同或飞机所有权证明文件`,
        material5: `与{compName}的合作案例`,
      },
      // 合作船公司
      shippingPartners: {
        label: '合作船公司',
        tooltip: `{ApprovedMaterials} 已经过SGS核验`,
        materialList: [
          `带约号的订舱单`,
          `与船司合作协议扫描件`,
          `与{compName}的合作案例`,
        ],
        material1: `带约号的订舱单`,
        material2: `与船司合作协议扫描件`,
        material3: `与{compName}的合作案例`,
      },
      // 合作航空公司
      airlinePartners: {
        label: '合作航空公司',
        tooltip: `{ApprovedMaterials} 已经过SGS核验`,
        materialList: [
          `IATA会员证书`,
          `航司颁发的订舱资质证明`,
          `与航司的包机、包板协议`,
          `购机合同或飞机所有权证明文件`,
          `与{compName}的合作案例`,
        ],
        material1: `IATA会员证书`,
        material2: `航司颁发的订舱资质证明`,
        material3: `与航司的包机、包板协议`,
        material4: `购机合同或飞机所有权证明文件`,
        material5: `与{compName}的合作案例`,
      },
      // 证书资质
      certificates: {
        NVOCC: {
          label: 'NVOCC',
          tooltip: `{ApprovedMaterials} 已经过SGS核验`,
          materialList: [`NVOCC证书`],
          material1: `NVOCC证书`,
        },
        IATA: {
          label: 'IATA',
          tooltip: `{ApprovedMaterials} 已经过SGS核验`,
          materialList: [`IATA证书`],
          material1: `IATA证书`,
        },
        FIATA: {
          label: 'FIATA',
          tooltip: `{ApprovedMaterials} 已经过SGS核验`,
          materialList: [`FIATA证书`],
          material1: `FIATA证书`,
        },
        CIFFA: {
          label: 'CIFFA',
          tooltip: `{ApprovedMaterials} 已经过SGS核验`,
          materialList: [`CIFFA证书`],
          material1: `CIFFA证书`,
        },
        ISO: {
          label: 'ISO',
          tooltip: `{ApprovedMaterials} 已经过SGS核验`,
          materialList: [`ISO证书`],
          material1: `ISO证书`,
        },
        AEO: {
          label: 'AEO',
          tooltip: `{ApprovedMaterials} 已经过SGS核验`,
          materialList: [`AEO证书`],
          material1: `AEO证书`,
        },
      },
    },

    // 混合后位于两部分之间
    // 更靠近分母更大的一边
    // 根据分母的反比确定线段的距离比、确定混合后的具体位置。
    membership: membership_cn,
    shopPage: shopPage_cn,
    bindCompany,
    common,
    m,
    rateProducts,
    header,
    homeIndex,
    joinUs,
    company,
    knowledge,
    riskControl,
    memberTools,
    standards,
    ...companySearch,
    ...membershipList,
    policy,
    resources,
    inquiryDetail,
    checkEmail,
    JCInsurance,
  }
})
